__turbopack_context__.v({
  "active": "side-nav-link-module__fnqilG__active",
  "active2": "side-nav-link-module__fnqilG__active2",
});
